import { externalLinkSegments } from '../../utils/externalLinkText';
import { serializeBioLink } from '../../utils/aboutLinks';

export function bioDocument(value) {
  return { type: 'doc', content: String(value ?? '').replace(/\r\n?|[\u2028\u2029]/g, '\n').split('\n').map(line => ({
    type: 'paragraph', content: externalLinkSegments(line).filter(part => part.text).map(part => part.href
      ? { type: 'externalLink', attrs: { href: part.href, label: part.customLabel || part.href, customLabel: part.customLabel || null } }
      : { type: 'text', text: part.text }),
  })) };
}

export function serializeBioContent(content) {
  let text = '';
  let blockSeen = false;
  content.forEach(node => {
    if (node.isBlock) {
      if (blockSeen) text += '\n';
      blockSeen = true;
      text += serializeBioContent(node.content);
    } else if (node.isText) text += node.text;
    else if (node.type.name === 'hardBreak') text += '\n';
    else if (node.type.name === 'externalLink') text += serializeBioLink(node.attrs);
  });
  return text;
}

export const serializeBioDoc = doc => serializeBioContent(doc.content);

// The biography accepts prose and links only. Clipboard paragraphs become
// inline breaks so excess newlines can be dropped without losing pasted words.
export function bioPasteNodes(content, schema, availableBreaks) {
  const nodes = [];
  const addBreak = () => {
    nodes.push(availableBreaks-- > 0 ? schema.nodes.hardBreak.create() : schema.text(' '));
  };
  const visit = fragment => {
    let blockSeen = false;
    fragment.forEach(node => {
      if (node.isBlock) {
        if (blockSeen) addBreak();
        blockSeen = true;
        visit(node.content);
      } else if (node.isText) {
        const parts = node.text.replace(/\r\n?|[\u2028\u2029]/g, '\n').split('\n');
        parts.forEach((part, index) => { if (index) addBreak(); if (part) nodes.push(schema.text(part)); });
      } else if (node.type.name === 'hardBreak') addBreak();
      else if (node.type.name === 'externalLink') nodes.push(node.mark([]));
    });
  };
  visit(content);
  return nodes;
}
